import React from 'react'

const Video = ({ url }) => {
  return (
    <div className='video-block'>
      <video controls>
        <source src={url} />
        Sorry, your browser doesn&apos;t support embedded videos.
      </video>
    </div>
  )
}

export default Video
